export function getItemById(items, id) {
    return items.find((item) => item.id === id);
}

export function truncateName(name, maxLength) {
    return name.length > maxLength ? name.substring(0, maxLength - 3) + "..." : name;
}
